module.exports = __webpack_public_path__ + "img/img3.5161c205.jpg";